import {languageProcessing} from '@axyseo/index.js';
const {createRegexFromArray, getClauses} = languageProcessing;

import Clause from '../values/Clause';
import auxiliaries from '../config/internal/passiveVoiceAuxiliaries.js';
import stopwords from '../config/stopWords.js';
const followingAuxiliaryExceptionWords = ['el', 'la', 'los', 'las', 'una'];

const options = {
  Clause,
  stopwords,
  auxiliaries: auxiliaries,
  regexes: {
    auxiliaryRegex: createRegexFromArray(auxiliaries),
    stopCharacterRegex: /([:,])(?=[ \n\r\t'"+\-»«‹›<>])/gi,
    followingAuxiliaryExceptionRegex: createRegexFromArray(followingAuxiliaryExceptionWords)
  }
};

/**
 * Gets the clauses from a sentence by determining sentence breakers.
 *
 * @param {string} sentence The sentence to split up in clauses.
 *
 * @returns {Array} The array with all clauses that have an auxiliary.
 */
export default function getSpanishClauses(sentence) {
  return getClauses(sentence, options);
}
